<template>
    <div>
        <div class="row">
            <div class="col">
                <h4 v-if="type === 'buy'">What's your max budget?</h4>
                <h4 v-else>What is the approximate value of your property?</h4>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="contain">
                <h4><strong class="blue-text-xl">{{ getValueAsCurrency }}.00<span v-if="estimatedValue === maxVal">+</span></strong></h4>
                <b-form-input type="range" v-model.number="estimatedValue" :min="minVal" :max="maxVal" :step="step"
                              @change="updateEstimatedValue(estimatedValue)" size="lg"/>
                <p class="center-80">adjust the price above by moving the blue dot left or right</p>
            </div>
        </div>
        <div class="row justify-content-center" v-if="type === 'sell'">
            <div class="contain footnote">
                <h4>
                    <strong class="green-text-lg">SAVE</strong> up to <strong class="green-text-lg">{{ getSavingsAsCurrency }}.00</strong><br/> When the Buyer doesn't have an Agent
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
    import {saveField} from "@/services/apiService";

    export default {
        name: "EstimateValue",
        props: ['value', 'type'],
        model: {
            prop: 'value',
            event: 'selected'
        },
        data() {
            return {
                estimatedValue: 400000,
                minVal: 150000,
                maxVal: 10000000,
                step: 5000
            }
        },
        methods: {
            formatCurrency: function (value) {
                if (typeof value !== "number") {
                    return value + '-nan';
                }
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0
                });
                return formatter.format(value);
            },
            updateEstimatedValue: function (value) {
                this.estimatedValue = value;
                this.$emit('selected', value);
                saveField('Est_Seller_Value', this.estimatedValue);
            }
        },
        mounted: function () {
            this.estimatedValue = this.value;
            if (this.type === 'buy') {
                this.minVal = 100000
                this.maxVal = 3000000
                this.step = 5000
                this.estimatedValue = 400000
            }
        },
        computed: {
            getValueAsCurrency() {
                return this.formatCurrency(this.estimatedValue)
            },
            getSavingsAsCurrency(){
                return this.formatCurrency((this.estimatedValue * 0.04))
            }
        }
    }
</script>

<style scoped>
.footnote{
    padding-top: 30px;
}
.green-text-lg {
    color:#00be6f;
    font-size:1.1em;
}
.blue-text-xl {
    color:rgb(0, 124, 255);
    font-size:1.5em;
}

input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    top: -9px;
    z-index: 1;
    width: 35px;
    height: 35px;
    border-radius: 45px;
}
</style>
